import { db, get_user_id } from "@/firebase";

export async function addFeedback(feedback) {
	const user_id = get_user_id();
	return db.collection("feedback").add({ feedback, user_id });
}
